import { render, staticRenderFns } from "./TableCurrentPermissions.vue?vue&type=template&id=4096ab9a&scoped=true&"
import script from "./TableCurrentPermissions.vue?vue&type=script&lang=js&"
export * from "./TableCurrentPermissions.vue?vue&type=script&lang=js&"
import style0 from "./TableCurrentPermissions.vue?vue&type=style&index=0&id=4096ab9a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4096ab9a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VCard,VCol,VIcon,VRow,VSpacer,VSwitch})
